/*****************
 * GA4
 */

dataLayer.push({ecommerce: null});
dataLayer.push({
    event: "view_item",
    ecommerce: {
        currency: Shopify.currency.active,
        price: activeVariant.price / 100,
        items: [
            {
                item_id: product.id,
                item_name: product.title,
                item_variant: activeVariant.title,
                item_category: product.type,
                price: activeVariant.price / 100,
                quantity: 1
            }
        ]
    }
});

/************
 Product Swiper
 ************/

// setup product swiper
let productImages = new Swiper("#productVisualSwiper");

// thumbnail
document.querySelectorAll(".productVisualThumbnailsImage").forEach(function (element) {
    element.addEventListener("click", function () {
        // determine index
        let index = getElIndex(this);

        // change active slide
        productImages.slideTo(index);
    });
});


/*****************
 * Product Reviews
 * *************/

if (window.ratingSnippet && (product.handle === "waterguru-sense" || product.handle === "waterguru-sense-sale")) {
    ratingSnippet("productStars", {
        store: "waterguru.com",
        color: "#fab101",
        linebreak: true,
        usePolaris: true,
        text: "Reviews",
        min_rating: 4,
    });
}

document.querySelectorAll('.productStars').forEach(function (element) {
    element.addEventListener("click", function () {
        window.scroll({
            behavior: "smooth",
            top: document.querySelector("#productReviews").offsetTop
        })
    })
})

/*****************
 * Product Bundles
 * *************/

document.querySelector("#productBundlesATC")?.addEventListener("click", async function () {
    // add loading animation
    this.classList.add("loading");

    let formData = {
        items: [{
            quantity: parseInt(document.querySelector(`.productBundlesItemInput:checked`).value),
            id: activeVariant.id,
        }]
    };

    // add deliveryType as a property if found in the url
    if (urlParams.get("deliveryType")) {
        formData.items[0].properties = {};
        formData.items[0].properties._deliveryType = urlParams.get("deliveryType");
    }

    // add product
    await addProduct(formData);

    // open cart
    await openCart();

    // GA4
    dataLayer.push({ecommerce: null});
    dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
            subscription_included: false,
            value: activeVariant.price * quantity / 100,
            currency: Shopify.currency.active,
            items: [{
                item_id: product.id,
                item_name: product.title,
                item_variant: activeVariant.title,
                item_category: product.type,
                price: activeVariant.price / 100,
                quantity: quantity,
                subscription_item: false,
            }]
        }
    });

    // remove loading animation
    this.classList.remove("loading");
});


/*************
 Adapters
 ************/

if (document.querySelector("#productAdapters")) {
    // preload all images
    Object.values(adapters).forEach(function (adapter) {
        preloadImage(adapter.media[adapter.media.length - 1].src)
    });

    // event listener for change
    document.querySelector("#productAdaptersSelect").addEventListener("change", function () {
        /*
        NOTE, adapter is undefined when we're looking at the DEFAULT product
        For example, when the adapter dropdown is set to its original position and there are no addons
         */

        // get adapter
        let adapter = adapters[this.value];

        // determine which image to use
        let image;
        if (adapter === undefined) {
            // first image is used for the default product
            image = product.featured_image;
        } else {
            // adapter products we use the last image
            image = adapter.media[adapter.media.length - 1].src;
        }

        // update image and thumbnail
        document.querySelector(".productVisualSwiperImage").src = `${image}&width=1000`;
        document.querySelector(".productVisualThumbnailsImage").src = `${image}&width=200`;

        // determine price
        let priceVal;
        if (adapter === undefined) {
            priceVal = product.price;
        } else {
            priceVal = product.price + adapter.price;
        }

        // update price
        document.querySelector("#productSummaryPriceMain").textContent = price(priceVal);

        // change slider to position on
        productImages.slideTo(0);
    });
}

/**************
 Product Subscriptions
 ***************/

// when subscription is changed, update pricing
document.querySelectorAll(".productSubscriptionLabelInput").forEach(function (element) {
    element.addEventListener("change", function () {
        // check for shadow products
        if (shadowProducts.length > 0) {
            const isSubscription = document.querySelector("#productSubscribe:checked") !== null;
            const subscriptionSavings = (1 - (activeVariant.selling_plan_allocations[0].price / activeVariant.selling_plan_allocations[0].compare_at_price)).toFixed(2) * 100;
            document.querySelector("#productSummaryPricePercent").textContent = `Save ${isSubscription ? subscriptionSavings : "5"}% OFF`;
            document.querySelector("#productSummaryPriceMain").textContent = price(isSubscription ? activeVariant.selling_plan_allocations[0].price : activeVariant.price * 0.95);

            // ugly price overrides
            document.querySelector("#productSummaryPriceMain").textContent = document.querySelector("#productSummaryPriceMain").textContent
                .replace("93.19", "93.18")
                .replace("83.39", "83.38")
                .replace("201.84", "201.83")
                .replace("225.59", "225.58");
        } else {
            // update price
            document.querySelector("#productSummaryPriceMain").textContent = price(activeVariant.price);

            // check for compare at price
            if (activeVariant.price < activeVariant.compare_at_price) {
                document.querySelector("#productSummaryPriceCompare").textContent = price(activeVariant.compare_at_price);
            }
        }
    });
});

/****************
 * Product Quantity
 **************/

// initialize quantity
let quantity = 1;

// quantity is not rendered on sense template
if (document.querySelector("#productSummaryQuantity")) {
    // minus
    document.querySelector("#productSummaryQuantityMinus").addEventListener("click", function () {
        // must not be less than 1
        if (quantity === 1) {
            return;
        }

        // decrement by 1
        quantity--;
        document.querySelector("#productSummaryQuantityValue").textContent = quantity;
    });

    // plus
    document.querySelector("#productSummaryQuantityPlus").addEventListener("click", function () {
        // limit quantity
        if (productToMaxQuantity[item.product_id] && quantity >= productToMaxQuantity[item.product_id]) {
            return;
        }

        // increment by 1
        quantity++;
        document.querySelector("#productSummaryQuantityValue").textContent = quantity;
    });
}

/**************
 Product ATC
 ***************/

document.querySelector("#productSummaryATC")?.addEventListener("click", async function () {
    // add loading animation
    document.querySelector("#productSummaryATC").classList.add("loading");

    let formData = {
        items: [{
            quantity: quantity,
            id: activeVariant.id,
        }]
    };

    // check for subscription
    const isSubscription = document.querySelector("#productSubscribe:checked") !== null;
    if (isSubscription) {
        formData.items[0].selling_plan = product.selling_plan_groups[0].selling_plans[0].id;
    }

    // check for adapters product
    if (document.querySelector("#productAdaptersSelect") && document.querySelector("#productAdaptersSelect").value !== "0") {
        formData.items.unshift({
            quantity: 1,
            id: adapters[document.querySelector("#productAdaptersSelect").value].variants[0].id
        });
    }

    // check if there are shadow products
    if (shadowProducts.length > 0) {
        // override items
        formData.items = formData.items = JSON.parse(JSON.stringify(shadowProducts));

        // check if we should remove the selling_plan since they're already included in the shadow products
        if (!isSubscription) {
            for (let i = 0; i < formData.items.length; i++) {
                delete formData.items[i].selling_plan;
            }
        }
    }

    // add deliveryType as a property if found in the url
    if (urlParams.get("deliveryType")) {
        // loop through all items
        for (let i = 0; i < formData.items.length; i++) {
            // check if properties exist
            if (!formData.items[i].properties) {
                formData.items[i].properties = {};
            }

            // add deliveryType
            formData.items[i].properties._deliveryType = urlParams.get("deliveryType");
        }
    }

    // add product
    await addProduct(formData);

    // open cart
    await openCart();

    // GA4
    dataLayer.push({ecommerce: null});
    dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
            subscription_included: document.querySelector("#productSubscribe:checked") !== null,
            value: activeVariant.price * quantity / 100,
            currency: Shopify.currency.active,
            items: [{
                item_id: product.id,
                item_name: product.title,
                item_variant: activeVariant.title,
                item_category: product.type,
                price: activeVariant.price / 100,
                quantity: quantity,
                subscription_item: document.querySelector("#productSubscribe:checked") !== null,
            }]
        }
    });

    // remove loading animation
    document.querySelector("#productSummaryATC").classList.remove("loading");
});

/************************
 Chemical Shipping
 ********************/

// update shipping method
if (document.querySelector("#productShipping")) {
    if (urlParams.get("deliveryType") === "branch") {
        document.querySelector("#productShipping").innerHTML = `This item is for same day delivery. <b>Free Delivery</b> on $75 chemical orders.`;
    } else if (urlParams.get("deliveryType") === "distributionCenter") {
        document.querySelector("#productShipping").innerHTML = `This item is for standard delivery. <b>Free Delivery</b> on $75 chemical orders.`;
    } else {

        const returnParams = new URLSearchParams({
            return_url: window.location.pathname,
            return_sku: activeVariant.sku,
        })

        // redirect to collection page since deliveryType is not found
        if (product.tags.includes("spa")) {
            window.location.href = `/collections/for-spas?${returnParams}`;
        } else {
            window.location.href = `/collections/for-pools?${returnParams}`;
        }
    }
}

/********************
 Product OOS
 *******************/

document.querySelector("#productOOS")?.addEventListener("submit", async function (e) {
    // prevent default
    e.preventDefault();

    // start loading
    document.querySelector("#productOOSFormSubmit").classList.add("loading");

    // add to waitlist
    await sendKlaviyoBackInStockRequest(document.querySelector("#productOOSFormEmail").value, activeVariant.id)

    // success
    document.querySelector("#productOOSTitle").textContent = `Thank You. We will notify you when item is back in stock.`;
    document.querySelector("#productOOSSubtitle").remove();
    document.querySelector("#productOOSFormEmail").remove();
    document.querySelector("#productOOSFormSubmit").remove();
});